import { Glyph } from '@uds/glyphs';
import { cssTheme, useTheme } from '@uds/theme-utils';
import { cx } from 'linaria';
import './select.stylesheet_1rjcyp7.css';
import { Children, isValidElement } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

let Size;
(function (Size) {
  Size["SMALL"] = "SMALL";
  Size["MEDIUM"] = "MEDIUM";
  Size["LARGE"] = "LARGE";
})(Size || (Size = {}));

const root = "rb51kyd";
const overlay = "o13jclui";
const select = "soq7vkp";
const icon = "i57sm3p";
const flag = "f1mec0dy";
const getClassNames = _ref => {
  let {
    error
  } = _ref;
  return {
    colors: {
      arrow: `${cssTheme.palette.grey02}`
    },
    flag,
    icon,
    overlay: cx(overlay, error != null && "o1jbr47l"),
    root,
    select
  };
};

// options can be nested inside other elements (i.e. <optgroup>)
// so we can't just grab the direct children, we need to dive in
// and deep-find the option nodes and then flatten them
const getOptionNodes = children => {
  const childrenArr = Children.toArray(children);
  return childrenArr.reduce((childs, node) => {
    if ( /*#__PURE__*/isValidElement(node)) {
      if (Array.isArray(node.props.children)) {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        if (!node.props.disabled) {
          return childs.concat(getOptionNodes(node.props.children));
        }
        return childs;
      }
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      if (!node.props.disabled) {
        return childs.concat(node);
      }
      return childs;
    }
    return childs;
  }, []);
};
const getSelectedNode = _ref => {
  let {
    nodes,
    value
  } = _ref;
  if (nodes.length > 0) {
    const selected = nodes.find(option => {
      return option.props.value === value;
    });
    return selected === null || selected === void 0 ? void 0 : selected.props;
  }
  return {
    value: ''
  };
};
const getNodes = _ref2 => {
  let {
    children,
    value
  } = _ref2;
  const nodes = getOptionNodes(children);
  const selected = getSelectedNode({
    nodes,
    value
  });
  return {
    selected,
    nodes
  };
};

const Select = _ref => {
  var _ref2, _childrenNodes$select, _childrenNodes$select2, _childrenNodes$select3, _childrenNodes$select4;
  let {
    children,
    value = '',
    label,
    placeholder,
    size = Size.MEDIUM,
    error,
    onChange = () => null,
    ...props
  } = _ref;
  const {
    theme: {
      curvature
    }
  } = useTheme();
  const classNames = getClassNames({
    error
  });
  const childrenNodes = children && getNodes({
    children,
    value
  });
  const selected = value === '' && placeholder != null ? {
    label: placeholder,
    value: ''
  } : {
    label: (_ref2 = (_childrenNodes$select = childrenNodes === null || childrenNodes === void 0 ? void 0 : (_childrenNodes$select2 = childrenNodes.selected) === null || _childrenNodes$select2 === void 0 ? void 0 : _childrenNodes$select2.label) != null ? _childrenNodes$select : childrenNodes === null || childrenNodes === void 0 ? void 0 : (_childrenNodes$select3 = childrenNodes.selected) === null || _childrenNodes$select3 === void 0 ? void 0 : _childrenNodes$select3.children) != null ? _ref2 : '',
    value: childrenNodes === null || childrenNodes === void 0 ? void 0 : (_childrenNodes$select4 = childrenNodes.selected) === null || _childrenNodes$select4 === void 0 ? void 0 : _childrenNodes$select4.value
  };
  return /*#__PURE__*/jsxs("div", {
    className: classNames.root,
    children: [/*#__PURE__*/jsxs("div", {
      className: classNames.overlay,
      "data-curvature": curvature,
      "data-size": size,
      children: [/*#__PURE__*/jsx("span", {
        children: selected.label
      }), /*#__PURE__*/jsx(Glyph, {
        name: "chevronDown",
        color: classNames.colors.arrow,
        className: classNames.icon
      })]
    }), /*#__PURE__*/jsx("select", {
      ...props,
      className: classNames.select,
      value: value,
      onChange: onChange,
      children: children
    })]
  });
};
var Select$1 = Select;

export { Select$1 as Select, Size };
